import React from "react";
import { Button } from "./ui/button";
import { Phone, CheckCircle2, Star, ShieldCheck } from "lucide-react";
import { COMPANY } from "../mock";

export default function Hero({ onBookNow }) {
  return (
    <section id="home" className="relative overflow-hidden hero-gradient text-white">
      {/* decorative copper pipe accent */}
      <div className="absolute -right-24 top-10 w-[420px] h-[420px] rounded-full bg-sky-400/20 blur-3xl" />
      <div className="absolute -left-32 bottom-0 w-[380px] h-[380px] rounded-full bg-sky-400/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-24 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur text-sky-200 text-xs font-semibold uppercase tracking-wider mb-5">
            <span className="w-2 h-2 rounded-full bg-sky-400 pulse-ring" />
            Available 24/7 in Sydney
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] mb-5">
            Sydney's Most Trusted
            <span className="block text-sky-300">Plumbing Group</span>
          </h1>
          <p className="text-lg text-white/85 max-w-xl mb-7">
            From burst pipes to complete hot water system installations, Cheerings Plumbing Group
            delivers prompt, professional and fully licensed residential, commercial, industrial
            and renovation plumbing services across all Sydney suburbs.
          </p>

          <ul className="grid grid-cols-2 gap-3 max-w-md mb-8">
            {["Fast Same-Day Service", "Honest Upfront Pricing", "Licensed & Insured", "100% Satisfaction"].map(
              (f) => (
                <li key={f} className="flex items-center gap-2 text-white/90 text-sm">
                  <CheckCircle2 size={18} className="text-sky-300 shrink-0" />
                  {f}
                </li>
              )
            )}
          </ul>

          <div className="flex flex-wrap gap-3">
            <Button
              onClick={onBookNow}
              className="bg-sky-500 hover:bg-sky-600 text-white font-bold px-7 py-6 text-base shadow-xl"
            >
              Book a Plumber
            </Button>
            <a href={`tel:${COMPANY.phoneLink}`}>
              <Button
                variant="outline"
                className="bg-white/10 border-white/30 text-white hover:bg-white hover:text-[#0a4f8a] font-semibold px-6 py-6 text-base backdrop-blur"
              >
                <Phone className="mr-2" size={18} /> {COMPANY.phone}
              </Button>
            </a>
          </div>

        </div>

        {/* Right card with plumber image */}
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10">
            <img
              src="https://customer-assets.emergentagent.com/job_d2c2d26c-9bf0-4200-96a9-e976003bafd2/artifacts/3rbceaqa_24799aa1-479b-4802-b2c3-b0627d751299.jpeg"
              alt="Cheerings plumber installing a water tank"
              className="w-full h-[460px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07304f]/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3 bg-white/95 backdrop-blur rounded-xl p-4 shadow-lg">
              <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center">
                <ShieldCheck className="text-sky-600" size={22} />
              </div>
              <div>
                <div className="font-bold text-[#0a4f8a]">Licensed NSW Plumbers</div>
              </div>
            </div>
          </div>
          {/* floating badge */}
          <div className="hidden md:flex absolute -top-5 -left-5 items-center gap-3 bg-white rounded-xl px-4 py-3 shadow-xl">
            <div className="text-4xl font-extrabold text-[#0a4f8a]">24/7</div>
            <div className="text-xs text-slate-600 leading-tight">
              Live Answering<br />Service
            </div>
          </div>
        </div>
      </div>

      {/* copper pipe band */}
      <div className="copper-band h-2 w-full" />
    </section>
  );
}
